import { Input } from "@/components/ui/input";
import { useEffect, useState } from "react";

interface CurrencyInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function CurrencyInput({
  value,
  onChange,
  placeholder,
}: CurrencyInputProps) {
  const [displayValue, setDisplayValue] = useState("");

  useEffect(() => {
    if (!value) {
      setDisplayValue("");
      return;
    }

    const numeric = value.replace(/\D/g, "");
    const number = Number(numeric) / 100;

    const formatted = number.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    setDisplayValue(formatted);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\D/g, "");
    onChange(raw);
  };

  return (
    <Input
      value={displayValue}
      onChange={handleChange}
      inputMode="numeric"
      placeholder={placeholder || "R$ 0,00"}
      spellCheck={false}
      autoCorrect="off"
      autoCapitalize="off"
    />
  );
}
